import React, { forwardRef, useEffect, useRef, Suspense, useMemo, useState } from "react";
import { Canvas, extend, useThree, useLoader, useFrame } from '@react-three/fiber'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { Center, Float, Text3D, GradientTexture, } from "@react-three/drei";
import * as THREE from 'three'
extend({ TextGeometry, OrbitControls })


const TextFloating = forwardRef(({ children, position, ...props }, ref) => {
    const [pos, setPos] = useState(new THREE.Vector3())
    const textRef = useRef()
    useEffect(() => {
        if (textRef.current &&position) {
            let vec3 = new THREE.Vector3()
            textRef.current.geometry.computeBoundingBox()
            textRef.current.geometry.boundingBox.getCenter(vec3)
            vec3.x=  -vec3.x+ position[0]
            vec3.y=   position[1]
            setPos(vec3)
        }
    }, [position, textRef.current])
    return (

        <Float position={pos} ref={ref} floatIntensity={5} speed={2}>
            <Text3D ref={textRef} font={'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/fonts/helvetiker_bold.typeface.json'} size={2} bevelSize={0.05}>
                {props.text}
                <meshBasicMaterial>
                    <GradientTexture
                        stops={[0, 1]} // As many stops as you want
                        colors={props.color} // Colors need to match the number of stops
                        size={1024} // Size is optional, default = 1024
                    />
                </meshBasicMaterial>
            </Text3D>
        </Float>



    )
})

export default TextFloating




